__turbopack_context__.v({
  "content": "Callout-module__jMalcG__content",
  "italic": "Callout-module__jMalcG__italic",
  "text": "Callout-module__jMalcG__text",
  "wrapper": "Callout-module__jMalcG__wrapper",
});
